import { LocalizedStrict } from "../../../../localization/components/AppLocalized"

type MeetingRoomBookingParticipantsProps = Readonly<{
    participants: number
    seats?: number
}>

export function MeetingRoomBookingParticipants({ participants, seats }: MeetingRoomBookingParticipantsProps) {
    if (seats === undefined) {
        return (
            <LocalizedStrict id="service-center-meeting-rooms-booking-participants" vars={{ participants }}>
                <span>{participants}</span>
            </LocalizedStrict>
        )
    }

    return (
        <LocalizedStrict id="service-center-meeting-rooms-booking-participants-of-seats" vars={{ participants, seats }}>
            <span>
                {participants} / {seats}
            </span>
        </LocalizedStrict>
    )
}
